export const getUsers = state => state.users;
export const getIdentityToken = state => state.identityToken;



// WEBPACK FOOTER //
// ./resources/scripts/greenmotion-shared/vuex/users/getters.js